/* eslint-disable max-statements */
import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";
import { getUploadedDocumentsStatuses } from "./utils";
import { reset as resetAppointmentFlow } from "../../../utils/appointment-flow";
import { getParsedPriceBreakup } from "../post-inspection-diy-container/selector";

export const INITIAL_STATE = {
    quack: null,
    inspectionResponse: {},
    auctionResponse: {},
    carDetails: {},
    thankYouDetails: {},
    pageLoading: false,
    hasError: false,
    priceBreakup: null,
    selectedInspectionDate: null,
    selectedInspectionTime: null,
    isNotServicible: false,
    isZoneChanged: false,
    vehicleBoughtCount: 0,
    cjDetail: null,
    virtualDetail: {},
    purchaseToken: {},
    bankVerification: {},
    caf: null,
    requiredDocumentList: {},
    dmsLoginData: {},
    pickupDetail: null,
    pickupSlot: null,
    campaign: null,
    doctet: {},
    postTokenDocuments: {},
    isNoBid: false,
    gaEventDetails: null,
    kmsDriven: null,
    activeTab: "PRICE",
    isFetched: false,
    carHealth: {}
};

export const setCurrentGaEventDetails = (state = INITIAL_STATE, { gaEventDetails }) => {
    return { ...state, gaEventDetails };
};

export const setCjDetail = (state = INITIAL_STATE, { data }) => {
    return { ...state, cjDetail: data };
};

export const setVirtualDetails = (state = INITIAL_STATE, { data }) => {
    return { ...state, virtualDetail: data };
};

export const setInspectionResponse = (state = INITIAL_STATE, { data }) => {
    return {
        ...state, inspectionResponse: {
            ...state.inspectionResponse,
            ...data
        }
    };
};

export const setAuctionResponse = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        auctionResponse: data
    };
};

export const setCarDetailsResponse = (state = INITIAL_STATE, {data}) => {
    return { ...state, carDetails: {...state.carDetails, ...data} };
};

export const setFinalStepThankYouDetailResponse = (state = INITIAL_STATE, {data}) => {
    return { ...state, thankYouDetails: data };
};

export const setPageLoading = (state = INITIAL_STATE, { pageLoading, loaderTitle }) => {
    return { ...state, pageLoading, loaderTitle };
};

export const setErrorStatus = (state = INITIAL_STATE, { hasError }) => {
    return { ...state, hasError };
};

export const setInspectionDate = (state = INITIAL_STATE, { selectedInspectionDate }) => {
    return {
        ...state,
        selectedInspectionDate,
        ...resetAppointmentFlow("selectedInspectionDate")
    };
};

export const setInspectionTime = (state = INITIAL_STATE, { selectedInspectionTime }) => {
    return {
        ...state,
        selectedInspectionTime,
        ...resetAppointmentFlow("selectedInspectionTime")
    };
};

export const setVehicleBoughtCount = (state = INITIAL_STATE, { count }) => {
    return { ...state, vehicleBoughtCount: count };
};

export const getPurchaseToken = (state = INITIAL_STATE, { purchaseToken }) => {
    return { ...state, purchaseToken };
};

export const setBankVerificationData = (state = INITIAL_STATE, { bankVerification }) => {
    return { ...state, bankVerification };
};

export const setDocumentData = (state = INITIAL_STATE, { documentData }) => {
    return { ...state, caf: documentData };
};

export const setRequiredDocuments = (state = INITIAL_STATE, { requiredDocumentList }) => {
    return { ...state, requiredDocumentList };
};

export const setDMSLoginData = (state = INITIAL_STATE, { dmsLoginData }) => {
    return { ...state, dmsLoginData };
};
export const setPickupSlot = (state = INITIAL_STATE, { slot }) => {
    const sortSlot =  slot.sort((a, b) => new Date(a.date) - new Date(b.date));
    return { ...state, pickupSlot: sortSlot };
};

export const setPickupDetail = (state = INITIAL_STATE, { detail }) => {
    return { ...state, pickupDetail: detail  };
};

export const setLoanDetail = (state = INITIAL_STATE, { detail }) => {
    return { ...state, loanDetails: detail  };
};

export const getCampaginPrice = (state = INITIAL_STATE, { data }) => {
    return { ...state, campaign: data  };
};

export const getPickupDocuments = (state = INITIAL_STATE, { data }) => {
    return { ...state, doctet: {
        ...state.doctet,
        ...data
    }  };
};

export const setDiyIntent = (state = INITIAL_STATE, {status}) => {
    const { purchaseRequest } = state.purchaseToken || {};
    return {...state, purchaseToken: {
        ...state.purchaseToken,
        purchaseRequest: {
            ...purchaseRequest,
            diyIntent: status
        }
    }};
};

export const setPostTokenDocuments = (state = INITIAL_STATE, { postTokenDocuments }) => {
    const { documents = {} } = postTokenDocuments || {};
    const counter = getUploadedDocumentsStatuses(documents);

    const { documents: alreadySavedDocuments = {} } = state.postTokenDocuments || {};
    const { isDocUploadByPassed = false } = alreadySavedDocuments || {};

    return {
        ...state,
        postTokenDocuments: {
            ...postTokenDocuments,
            ...counter,
            documents: {
                ...documents,
                isDocUploadByPassed
            }
        }
    };
};

export const setPostInspectionDiyResponse = (state = INITIAL_STATE, data) => {
    const {
        inspectionResponse,
        auctionResponse,
        carDetails,
        priceBreakup,
        postTokenDocuments,
        purchaseToken,
        doctet,
        pickupDetail,
        isNoBid
    } = data;

    const counter = getUploadedDocumentsStatuses(postTokenDocuments.documents);

    return {
        ...state,
        inspectionResponse,
        auctionResponse,
        carDetails,
        priceBreakup,
        purchaseToken,
        pickupDetail,
        isNoBid,
        postTokenDocuments: {
            ...postTokenDocuments,
            ...counter
        },
        doctet: {
            ...state.doctet,
            ...doctet
        }
    };
};

export const setDiyDetails = (state = INITIAL_STATE, {data = {}}) => {
    return { ...state, ...data };
};

export const setKmsDriven = (state = INITIAL_STATE, {kmsDriven}) => {
    return { ...state, kmsDriven };
};

export const setActiveTab = (state = INITIAL_STATE, {activeTab}) => {
    return { ...state, activeTab };
};

export const setScreenDetails = (state = INITIAL_STATE, { details }) => {
    const {
        isResetAuctionFlowActive = false,
        isSelfNegoFlowActive = false,
        isAuctionNotStarted = false
    } = details || {};
    return {
        ...state,
        inspectionResponse: {
            ...state.inspectionResponse,
            isResetAuctionFlowActive,
            isSelfNegoFlowActive,
            isAuctionNotStarted
        }
    };
};

export const setPriceDiscovery = (state = INITIAL_STATE, {priceDiscovery}) => {
    return {
        ...state,
        inspectionResponse: {
            ...state.inspectionResponse,
            priceDiscovery
        }
    };
};

export const setSecondaryPhone = (state = INITIAL_STATE, {maskedSecondaryPhone}) => {
    return {
        ...state,
        inspectionResponse: {
            ...state.inspectionResponse,
            maskedSecondaryPhone
        }
    };
};

export const setPriceBreakup = (state = INITIAL_STATE, {data}) => {
    const { inspectionResponse, priceBreakup } = state;
    const { showServiceCharge = true, priceDo: auctionResponse } = inspectionResponse;
    const { offeredPrice } = auctionResponse || {};
    const { deductions } = priceBreakup;
    return {
        ...state,
        priceBreakup: {
            ...state.priceBreakup,
            ...getParsedPriceBreakup({priceBreakup: data, showServiceCharge, offeredPrice, deductions})
        }
    };
};

export const setSelfNegoDetails = (state = INITIAL_STATE, {data}) => {
    return {
        ...state,
        selfNegoKycDetails: {
            ...state.selfNegoKycDetails,
            ...data
        }
    };
};

export const setHammerSwipe = (state = INITIAL_STATE, {enable}) => {
    return {
        ...state,
        enableSwipe: enable
    };
};

export const setCarHandoverDetails = (state = INITIAL_STATE, { details }) => {
    return {
        ...state,
        ...details
    };
};
export const setUpdateImpressions = (state = INITIAL_STATE, { impression }) => {
    const updatedImpressionData = state.inspectionResponse.impressionData.some(city => city.cityId === impression.cityId)
        ? state.inspectionResponse.impressionData.map(city =>
            city.cityId === impression.cityId ? impression : city)
        : [...state.inspectionResponse.impressionData, impression];

    const impressionsCount = updatedImpressionData.reduce((total, city) => total + city.totalImpression, 0);
    return {
        ...state,
        inspectionResponse: {
            ...state.inspectionResponse,
            impressionData: updatedImpressionData,
            impressionsCount
        }
    };
};

export const setIsFetched = (state = INITIAL_STATE, {isFetched}) => {
    return { ...state, isFetched };
};

export const rejectDnpOffer = (state = INITIAL_STATE, { dnpPriceConfirmationEnabled }) => {
    return {
        ...state,
        inspectionResponse: {
            ...state.inspectionResponse,
            featureData: {
                ...state.inspectionResponse.featureData,
                dnpPriceConfirmationEnabled
            }
        }
    };
};

export const setCarHealth = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        carHealth: {
            ...state.carHealth,
            reportData: {
                ...state.carHealth.reportData,
                ...data
            }
        }
    };
};

export const resetCarHealth = (state = INITIAL_STATE) => {
    return {
        ...state,
        carHealth: {}
    };
};

export const HANDLERS = {
    [Types.SET_INSPECTION_RESPONSE]: setInspectionResponse,
    [Types.SET_CJ_DETAIL]: setCjDetail,
    [Types.SET_VIRTUAL_DETAILS]: setVirtualDetails,
    [Types.SET_AUCTION_RESPONSE]: setAuctionResponse,
    [Types.SET_CAR_DETAILS_RESPONSE]: setCarDetailsResponse,
    [Types.SET_PAGE_LOADING]: setPageLoading,
    [Types.SET_ERROR_STATUS]: setErrorStatus,
    [Types.SET_INSPECTION_DATE]: setInspectionDate,
    [Types.SET_INSPECTION_TIME]: setInspectionTime,
    [Types.GET_PURCHASE_TOKEN]: getPurchaseToken,
    [Types.SET_BANK_VERIFICATION_DATA]: setBankVerificationData,
    [Types.SET_DOCUMENT_DATA]: setDocumentData,
    [Types.SET_REQUIRED_DOCUMENTS_LIST]: setRequiredDocuments,
    [Types.SET_DMS_LOGIN_DATA]: setDMSLoginData,
    [Types.SET_PICKUP_DETAIL]: setPickupDetail,
    [Types.SET_PICKUP_SLOT]: setPickupSlot,
    [Types.SET_CAMPAGIN_PRICE]: getCampaginPrice,
    [Types.GET_PICKUP_DOCUMENTS]: getPickupDocuments,
    [Types.SET_POST_TOKEN_DOCUMENTS]: setPostTokenDocuments,
    [Types.SET_CURRENT_GA_EVENT_DETAILS]: setCurrentGaEventDetails,
    [Types.SET_DIY_DETAILS]: setDiyDetails,
    [Types.SET_KMS_DRIVEN]: setKmsDriven,
    [Types.SET_SCREEN_DETAILS]: setScreenDetails,
    [Types.SET_ACTIVE_TAB]: setActiveTab,
    [Types.SET_DIY_INTENT]: setDiyIntent,
    [Types.SET_PRICE_DISCOVERY]: setPriceDiscovery,
    [Types.SET_PRICE_BREAKUP]: setPriceBreakup,
    [Types.SET_SELF_NEGO_DETAILS]: setSelfNegoDetails,
    [Types.SET_HAMMER_SWIPE]: setHammerSwipe,
    [Types.SET_LOAN_DETAIL]: setLoanDetail,
    [Types.SET_CAR_HANDOVER_DETAILS]: setCarHandoverDetails,
    [Types.SET_UPDATED_IMPRESSIONS]: setUpdateImpressions,
    [Types.SET_SECONDARY_PHONE]: setSecondaryPhone,
    [Types.SET_IS_FETCHED]: setIsFetched,
    [Types.SET_DNP_OFFER]: rejectDnpOffer,
    [Types.SET_CAR_HEALTH]: setCarHealth,
    [Types.RESET_CAR_HEALTH]: resetCarHealth
};

export default createReducer(INITIAL_STATE, HANDLERS);
